<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="message">
            <defs>
                <path id="okuh0mh81a" d="M19.9,7c0,0,0-0.1,0-0.1c-0.3-0.9-1.1-1.4-2.1-1.4c-3.9,0-7.7,0-11.6,0c-0.1,0-0.3,0-0.4,0
                C4.9,5.6,4.1,6.4,4,7.3c0,0.1,0,0.1,0,0.2c0,0.7,0,1.4,0,2.2v4.7c0,0.7,0,1.5,0,2.2c0,0.1,0,0.1,0,0.2c0.2,1.1,1,1.8,2.2,1.8
                c2.3,0,4.6,0,6.9,0c1.6,0,3.2,0,4.7,0c1.2,0,2.1-0.9,2.2-2c0-0.8,0-1.5,0-2.3V8.6c0-0.2,0-0.4,0-0.6C20,7.7,20,7.3,19.9,7z
                M5.9,6.8c0.1,0,0.3,0,0.4,0c3.8,0,7.6,0,11.4,0c0.3,0,0.6,0.1,0.8,0.3c0.1,0.2,0.1,0.3-0.1,0.4c-0.5,0.3-1,0.7-1.5,1
                c-0.7,0.5-1.4,1-2.1,1.5c-0.7,0.5-1.4,1-2.1,1.5c-0.2,0.1-0.4,0.2-0.6,0.4c-0.1,0.1-0.2,0.1-0.3,0c-0.4-0.3-0.8-0.6-1.2-0.8
                C9.8,10.4,8.9,9.8,8,9.2C7.2,8.6,6.4,8,5.5,7.4c-0.1,0-0.1-0.1-0.2-0.1C5.4,7,5.6,6.9,5.9,6.8z M18.7,14.2c0,0.8,0,1.5,0,2.3
                c-0.2,0.5-0.4,0.7-1,0.7c-3.8,0-7.6,0-11.4,0c-0.6,0-0.8-0.2-1-0.7c0-0.7,0-1.5,0-2.2V8.8C5.6,9,5.8,9.2,6,9.3
                c0.9,0.6,1.8,1.3,2.6,1.8c1,0.7,2,1.4,3,2.1c0.3,0.2,0.5,0.1,0.8,0c0.5-0.4,1.1-0.7,1.6-1.2c0.2-0.2,0.5-0.3,0.7-0.5
                c0.7-0.4,1.4-1,2.1-1.4c0.6-0.4,1.2-0.8,1.9-1.3V14.2z" />
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask :id="`${id}dy4ytx10kb`" fill="#fff">
                    <use xlink:href="#okuh0mh81a"/>
                </mask>
                <g class="path" :fill="fill" :mask="`url(#${id}dy4ytx10kb)`">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-message',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        id: {
            type: Number,
            default: 1
        },
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>